import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12
  },
  filters: {
    display: 'grid',
    gridTemplateColumns: '1fr 3fr',
    gap: 16,
    marginBottom: 16,
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
      gridTemplateRows: '1fr 1fr',
      gap: 0
    }
  },
  inputContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0
    }
  }
}))

export default useStyles
